import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center align-self-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Загружаем форму...", -1)
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column align-center align-self-center"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "fb-form my-auto fb-success"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title mt-4" }, /*#__PURE__*/_toDisplayString("Ваш отчет отправлен"), -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1" }, /*#__PURE__*/_toDisplayString("Спасибо за обратную связь!"), -1)
const _hoisted_8 = {
  key: 3,
  class: "fb-form"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "fb-form__title" }, "Форма обратной связи", -1)
const _hoisted_10 = { class: "fb-form__row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  key: 0,
  class: "v-limit-slider v-fb-slider v-locale--is-ltr"
}
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "description" }
const _hoisted_15 = {
  key: 1,
  class: "fb-textarea"
}
const _hoisted_16 = { class: "title mb-3" }

import { onMounted, reactive, ref, watch } from 'vue';
import { feedbackApi } from '@/api/feedback';
import { replace } from '@/utils/vue';
import { useErrors } from '@/utils/use-errors';
import SkolkovoHeader from '@/components/SkolkovoHeader.vue';
import stubSvg from '@/assets/stub.svg'

type Column = { id: string, name: string, type: string, choises?: { [key: string]: string }, info?: { [key: string]: string } }

export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackForm',
  setup(__props) {

const status = ref('init')
const columns = reactive<Column[]>([])
const rowColumns = reactive<Column[]>([])
const data = reactive<{ programs: any[], teams: any[], trackers: any[], pollId: string }>({ programs: [], teams: [], trackers: [], pollId: "" })
const values = reactive<any>({})

onMounted(async () => {
  try {
    const formId = window.location.pathname.slice(4)
    const [ formData, info ] = await Promise.all([
      feedbackApi.getFeedbackForm(),
      feedbackApi.getBaseInfo(formId)
    ])

    for (let data of formData.columns) {
      const name = data.metadata?.title || data.name
      const type = data.type
      const id = data.name
      const column: Column = { id, name, type  }

      if (type === "number") {
        values[id] = 1
      }
      if (id === "Программа" || id === "Команда" || id === "Трекер") {
        rowColumns.push(column)
      } else {
        columns.push(column)
      }
    }
    replace(data, info)    
    status.value = "ready"
  } catch(e) {
    status.value = "error"
  }
})

const getSelectItems = (name: string) => {
  if (name === "Программа") {
    return data.programs
  }
  if (name === "Команда" || name === "Название команды") {
    if (!values["Программа"]) return []
    return data.teams.filter(item => item.programId === values["Программа"])
  }
  if (name === "Трекер") {
    if (!values["Программа"] || !values["Команда"]) return []
    const team = data.teams.find(item => item.id === values["Команда"])
    return data.trackers.filter(item => item.id === team.trackerId)
  }
  return []
}

watch(() => values["Программа"], () => {
  values["Команда"] = null
})
watch(() => values["Команда"], (teamId) => {
  if (!teamId) {
    values["Трекер"] = null
    return
  }
  const team = data.teams.find(item => item.id === values["Команда"])
  const tracker = data.trackers.find(item => item.id === team.trackerId)
  values["Трекер"] = tracker?.id || null
})

const descriptions = [
  "Отсутсвует",
  "Абсолютно не соответствует",
  "По большей части не соответствует",
  "Скорее соответствует",
  "По большей части соответствует",
  "Полностью соответствует"
]

const pending = ref(false)
const errors = useErrors(values)

const submit = async () => {
  pending.value = true
  try {
    let hasError = false
    for (let column of [...rowColumns, ...columns]) {
      if (typeof values[column.id] !== "number" && !values[column.id]) {
        errors[column.id] = "Поле обязательно к заполнению"
        hasError = true
      }
    }
    if (hasError) {
      console.log(errors)
      return false
    }
    const _values = { ...values }
    _values["Программа"] = [ _values["Программа"] ]
    _values["Команда"] = [ _values["Команда"] ]
    _values["Трекер"] = [ _values["Трекер"] ]
    
    await feedbackApi.sendForm(data.pollId, _values)
    status.value = "complete"
  } finally {
    pending.value = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SkolkovoHeader),
    _createVNode(_component_v_layout, { class: "justify-center fb-form-wrapper" }, {
      default: _withCtx(() => [
        (status.value === 'init')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary"
              }),
              _hoisted_2
            ]))
          : (status.value === 'error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(" Ссылка на форму недействительна "),
                _createElementVNode("img", {
                  src: _unref(stubSvg),
                  class: "mt-4",
                  width: "100"
                }, null, 8, _hoisted_4)
              ]))
            : (status.value === 'complete')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_v_icon, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-check-circle")
                    ]),
                    _: 1
                  }),
                  _hoisted_6,
                  _hoisted_7
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowColumns, (column) => {
                      return (_openBlock(), _createBlock(_component_v_select, {
                        modelValue: values[column.id],
                        "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                        "error-messages": _unref(errors)[column.id],
                        items: getSelectItems(column.name),
                        label: column.name,
                        "item-title": "name",
                        "item-value": "id",
                        variant: "outlined",
                        style: {"flex":"1 1 50px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages", "items", "label"]))
                    }), 256))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (column, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (column.type === 'number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString((index+1) + ". "+ column.name), 1),
                            _createVNode(_component_v_slider, {
                              modelValue: values[column.id],
                              "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                              "track-size": "6",
                              "thumb-size": "14",
                              min: 1,
                              max: 5,
                              step: "1",
                              "show-ticks": "always",
                              "tick-size": "0",
                              "hide-details": "",
                              ticks: [ 1, 2, 3, 4, 5 ],
                              class: "mb-6"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(descriptions[values[column.id]]), 1)
                          ]))
                        : (column.type === 'multilineText')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, _toDisplayString((index+1) + ". "+ column.name), 1),
                              _createVNode(_component_v_textarea, {
                                modelValue: values[column.id],
                                "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                                rows: "2",
                                variant: "outlined",
                                color: "primary",
                                "error-messages": _unref(errors)[column.id]
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages"])
                            ]))
                          : (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 2,
                              modelValue: values[column.id],
                              "onUpdate:modelValue": ($event: any) => ((values[column.id]) = $event),
                              variant: "outlined",
                              label: column.name,
                              "error-messages": _unref(errors)[column.id]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"]))
                    ]))
                  }), 256)),
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      disabled: pending.value,
                      onClick: submit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отправить ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]))
      ]),
      _: 1
    })
  ], 64))
}
}

})